
const ENVIRONMENT_TO_DOMAIN_MAP = {
  DEVELOPMENT: "https://develop.spotlyte.mwkci.com",
  STAGING: "https://stage.spotlyte.mwkci.com",
  DEPLOY: "https://deploy-preview-94--thespotlyte.netlify.com"
};


const MODEL_TYPE_TO_PREVIEW_ROUTE_MAP = {
  landing_page: "preview/landing",
  article: "preview/articles",
  author: "preview/authors",
  tag: "preview/tags",
  treatment_guide: "preview/treatment-guides"
};

function get_preview_url(ITEM_ID, CURRENT_ENVIRONMENT, MODEL_TYPE) {
  const DOMAIN = ENVIRONMENT_TO_DOMAIN_MAP[CURRENT_ENVIRONMENT];
  const ROUTE = MODEL_TYPE_TO_PREVIEW_ROUTE_MAP[MODEL_TYPE];

  return [DOMAIN, ROUTE, ITEM_ID].join("/");
}

export default get_preview_url;
